const data = [
  {
    title: 'Transport Application',
    subtitle: 'Community Schools',
    image: 'n/a',
    link: 'n/a',
    date: '2023-2-20',
    desc:
      'Evaluated the team’s initial design and planning phase for a minimum-viable-product (MVP) release.' 
      + 'Implemented an external API to retrieve both student and staff data, seamlessly integrating it with our Django backend. '
      + ' Leveraged React Native for the front-end, employing various hooks and state elements for effective data manipulation and dynamic workout population.',
  },
  {
    title: 'Pirates Booty',
    subtitle: 'On the go workout APP',
    image: 'n/a',
    link: 'https://gitlab.com/hr-data-pirates/pirates-booty/-/blob/main-submission/README.md',
    date: '2022-7-01',
    desc:
      'Assessed team’s design and plan for minimum-viable-product for initial release. '
      + 'Collaborated with engineers to address and solve critical blocking issues throughout '
      + 'application development while promoting an agile work environment. '
      + 'Integrated API to dynamically populate workouts with a combination of two databases, data'
      + ' data manipulation with different hook and state elements. '
  },
  {
    title: 'Conference GO',
    subtitle: 'Resource for in-person and virtual conference planner for attendees and presenters',
    image: 'n/a',
    link: 'https://github.com/ShelenElls/ConferenceJS/blob/main/README.md',
    date: '2022-6-01',
    desc:
      ' Refactored a Django-based monolith application into microservices with modern architecture'
      +'utilizing React components.'
      + ' RabbitMQ pub/sub and middleware queuing between multiple microservices '
      + 'for efficient backend data communication '
      + 'and multiple third-party APIs utilizing anti-corruption layers'
  },
  {
    title: 'CarCar',
    subtitle: 'The premiere solution for automobile dealership management!',
    image: 'n/a',
    link: 'https://github.com/ShelenElls/CarCar/blob/main/README.md',
    date: '2022-6-01',
    desc:
      'Designed the microservice-based application utilizing 7 Docker containers'
      + 'to ensure data integrity and horizontal scalability.'
      + 'Developed database communication by using polling techniques to share data between the microservices.'
      + 'Collaborated as a pair designing bounded contexts through the finished product.'
  },
];

export default data;
